import React, { FC, useEffect, useRef, useState } from 'react';
import DescLabel from 'src/components/atoms/label/DescLabel';
import TableGrid from 'src/components/atoms/grid/TableGrid';
import AttachDropbox from 'src/components/molecules/content/Attach/AttachDropbox';
import DefaultButton from 'src/components/atoms/buttons/DefaultButton';
import { creditcardDataStore } from 'src/store/creditcard';
import { setDeDataStore } from 'src/fetch/data/store';
import { fetchPdfFileData, fetchPdfFileReset } from 'src/fetch/stepC';
import {
  settlementNtsDataStore,
  ntsFileDataStore,
  settlementDataStore,
} from 'src/store/settlementInfo';
import { errorModalViewStore, loadingModalViewStore } from 'src/store/modal';
import { initDataStore } from 'src/store/taxData';
import { useQueryClient } from '@tanstack/react-query';
import { getMemberInfo } from 'src/utils/common';
import { gridOption } from './gridOption';
import './style.scss';

interface Props {
  data: any;
}

const HomeTaxPdf: FC<Props> = ({ data }) => {
  const userInfoData: any = getMemberInfo();
  const queryClient = useQueryClient();
  const errorModalState = errorModalViewStore((state: any) => state.set);
  const loadingSate = loadingModalViewStore((state: any) => state.set);
  const infoDataState = initDataStore((state: any) => state.bind);

  const creditcardDataState = creditcardDataStore((state: any) => state.bind);

  // 정산결과
  const settlementBindParam = settlementDataStore((state: any) => state.bindParam);
  const settlementParam = settlementDataStore((state: any) => state.param);
  // 정산결과(NTS)
  const ntsInfoBindParam = settlementNtsDataStore((state: any) => state.bindParam);
  const ntsInfoParam = settlementNtsDataStore((state: any) => state.param);
  // NTS 업로드파일 데이터
  const ntsFileBindParam = ntsFileDataStore((state: any) => state.bindParam);
  const ntsFileParam = ntsFileDataStore((state: any) => state.param);

  const dataSet = {};
  const setData = data;
  const totalCount = 1;
  const bindStateData = setDeDataStore(state => state.bindData);
  const optionSet: any = gridOption(setData, totalCount, bindStateData);
  const [attachState, setAttachState] = useState({ files: [] });

  const stateOption: any = {
    label: optionSet.label || [],
    data: optionSet.data || [],
    styleDef: optionSet.styleDef,
    rowStyleDef: {},
    totalCount,
  };

  const pageInfo = {
    current: 1,
    totalCount: totalCount,
    size: 5,
    viewCount: 5,
  };
  const rowClickEvt = () => {};
  const pagingClick = () => {};
  const sortClickEvt = () => {};
  const resetEvt = () => {
    const param = {};
    fetchPdfFileReset(
      param,
      errorModalState,
      infoDataState,
      loadingSate,
      queryClient,
      (resData: any) => {}
    );
  };

  useEffect(() => {
    const attachFile = attachState.files || [];
    if (attachFile.length > 0) {
      const param = { ...userInfoData, attachFile };
      console.log('attachFile:', param);

      fetchPdfFileData(
        param,
        errorModalState,
        infoDataState,
        creditcardDataState,
        loadingSate,
        queryClient,
        (resData: any) => {
          // Init
          const initialSeq = settlementParam.initialSeq || 0;
          settlementBindParam({ initialSeq: initialSeq + 1 });
          const initialNtsSeq = ntsInfoParam.initialSeq || 0;
          ntsInfoBindParam({ initialSeq: initialNtsSeq + 1 });
          const initialFileSeq = ntsFileParam.initialSeq || 0;
          ntsFileBindParam({ initialSeq: initialFileSeq + 1 });
          setAttachState({ files: [] });
        }
      );
    }
  }, [attachState]);

  return (
    <section className="_step_c_insert_pdf">
      <div className="_content">
        <div className="_reset_attach_box">
          <DefaultButton
            text="RESET"
            clickEvent={e => resetEvt()}
            icon=""
            type="type1"
            styleDef={{ width: '70px', height: '30px', fontSize: '11px' }}
          />
        </div>
        <div className="_attach_box">
          <AttachDropbox
            attachState={attachState}
            setAttachState={setAttachState}
            subDesc={
              <div className="_sub_label">
                <div className="_label">Supports</div>
                <div className="_value">PDF</div>
              </div>
            }
          />
        </div>
      </div>
    </section>
  );
};

export default HomeTaxPdf;
